
import http from '@/config/http.js';
import store from '@/store/index.js';
let dic = store.state.dic;
import { getOrgOptions } from "@/libs/searchSelect";

export default function Configs(that) {
    const searchItems = [
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: dic._COLLEGE_OPTIONS,
            clearable: true,
            change(data) {
                that.searchItems[1].options = [];
                that.searchItems[2].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    let params = {
                        parentId: data,
                        type: 'department',
                    }
                    getOrgOptions(that, params, 0, null);
                }
            },
        },
        {
            label: "专业",
            span: 6,
            placeholder: '请选择专业',
            type: 'select',
            model: "majorId",
            clearable: true,
            options: [],
            change(data) {
                let params = {
                    parentId: data,
                    type: 'class'
                }
                that.searchItems[2].options = [];
                that.pageParams.classId = '';
                if (data) {
                    getOrgOptions(that, params, 2, null)
                }
            },
        },
        {
            label: "班级",
            span: 6,
            placeholder: '请选择班级',
            type: 'select',
            model: "classId",
            clearable: true,
            options: [],
        },
        {
            label: "年级",
            span: 6,
            type: 'year',
            model: "grade",
            clearable: true,
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 6,
            model: "studentNo"
        },
        // {
        //     label: "身份证号",
        //     span: 6,
        //     model: "idCard",
        // },
        {
            label: "姓名",
            span: 6,
            model: "studentName",
        },
        {
            label: "性别",
            span: 6,
            type: 'select',
            options: dic._SEXS,
            model: "sex",
            clearable: true,
        },
        {
            label: "培养层次",
            span: 6,
            type: 'select',
            options: dic._ACADEMICDEGREE,
            model: "academicDegree",
            clearable: true,
        },
        {
            label: "学制",
            span: 6,
            type: 'select',
            options: dic._ACADEMICYEAR,
            model: "academicYear",
            clearable: true,
        },
    ]
    const tableColumns = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,
        },
        // {
        //     label: "年级",
        //     prop: "enrollmentYear",
        //     align: "center",
        //     show: true
        // },

        {
            label: "性别",
            prop: "sexName",
            align: "center",
            show: true
        },
        {
            label: "联系方式",
            prop: "phoneNumber",
            align: "center",
            show: true,
            minWidth: 140,
        },
        // {
        //     label: "证件类型",
        //     prop: "idCardType",
        //     align: "center",
        //     show: true
        // },{
        //     label: "证件号码",
        //     prop: "idCard",
        //     align: "center",
        //     show: true
        // },
        // {
        //     label: "学籍状态",
        //     prop: "studentStatus",
        //     align: "center",
        //     show: true
        // },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        // {
        //     label: "系别",
        //     prop: "departmentName",
        //     align: "center",
        //     show: true,
        //     minWidth: 180,
        // },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '80px',
            show: true
        }
    ]
    return {
        searchItems,
        tableColumns,
    }
}
